// export const SET_IS_FOOTER_VISIBLE = 'SET_IS_FOOTER_VISIBLE'
export const SET_MESSAGE = 'SET_MESSAGE'
